import React from 'react';
import { Grid } from '@material-ui/core';
import Anchor from '../Anchor';

export default ({ children, id = '', className = '', ...props }) => (
  <Grid container className={className} {...props}>
    {id ? <Anchor id={id}/> : null}
    {children}
  </Grid>
);